import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { InputDatepickerNewComponent } from '../../components/input-datepicker-new/input-datepicker-new.component';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import RestService from '../../services/core-rest.service';
import moment from 'moment';
import DialogServices from '../../services/dialog.service';
import {MatOption} from "@angular/material/core";
import {MatSelect, MatSelectTrigger} from "@angular/material/select";
import Session from "../../utils/session.service";
import {
    ModalSuccessTrainingProgramCreationComponent
} from "../modal-success-training-program-creation/modal-success-training-program-creation.component";
@Component({
    standalone: true,
    selector: 'modal-training-program-selection',
    templateUrl: './modal-training-program-selection.component.html',
    imports: [CommonModule, TranslatePipe, LoaderOverlayComponent, InputDatepickerNewComponent, FormsModule, MatOption, MatSelect, MatSelectTrigger]
})
export class ModalTrainingProgramSelectionComponent implements OnInit {
    private restService: RestService = inject(RestService);
    private dialogRef = inject(MatDialogRef<ModalTrainingProgramSelectionComponent>);
    private data = inject(MAT_DIALOG_DATA);
    private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
    private dialogServices: DialogServices = inject(DialogServices);
    private session: Session = inject(Session);

    vm: any = undefined;

    constructor() {
        this.vm = this;
    }

    ngOnInit() {
        Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);

        this.vm.getTrainingProgramText = this.getTrainingProgramText;
        this.vm.submit = this.submit;
        this.vm.close = this.close;

        this.initialize();
    }

    initialize() {
        this.vm.dateRangeMin = moment(new Date()).toDate();
        this.vm.dateRangeModel = {
            start: moment(new Date()).toDate(),
            end: moment().add(1, 'months').toDate()
        };
        this.vm.initialized = true;
        this.vm.user = this.session.getSession().user;

        this.restService.getTrainingPrograms()
            .then((response) => {
                this.vm.trainingPrograms = response;
                this.vm.initialized = true;
                if(this.vm.trainingProgramCode) {
                    this.vm.selectedTrainingProgram = this.findTrainingProgramByVersionCode(this.vm.trainingProgramCode);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    submit() {
        this.vm.submitted = true;
        if (!this.vm.trainingProgramCode) return;
        this.vm.processing = true;

        const params: any = {
            startDate: moment(this.vm.dateRangeModel.start).format('YYYYMMDD'),
            endDate: moment(this.vm.dateRangeModel.end).format('YYYYMMDD'),
            trainingProgramCode: this.vm.trainingProgramCode,
            deselectNotActivated: this.vm.deselectNotActivated,
            isAllEmployeesSelected: this.vm.isAllEmployeesSelected,
            groupName: this.vm.groupName ? this.vm.groupName : ''
        };

        const payload = this.vm.exceptionalEmployeeIds || [];
        this.restService.assignTrainingProgram(params, payload)
            .then((response) => {
                this.vm.processing = false;
                this.dialogRef.close(response || true);
                this.openSuccessModalDialog();
            })
            .catch((error) => {
                console.log(error);
                this.vm.processing = false;
            });
    }

    getTrainingProgramText(trainingProgram) {
        if (!trainingProgram) return this.angularFilterHelperService.translate('Training.Selection.Program_Placeholder');
        return trainingProgram.title;
    }


    close() {
        this.dialogRef.close(undefined);
    }

    findTrainingProgramByVersionCode(versionCode: string): any | null {
        return this.vm.trainingPrograms.find(q => q.versionCode === versionCode) || null;
    }

    openSuccessModalDialog() {
        this.dialogServices.show({
            controller: ModalSuccessTrainingProgramCreationComponent,
            clickOutsideToClose: false,
            escapeToClose: false,
            multiple: false,
            width: '500px'
        });
    }
}
